import { render, staticRenderFns } from "./DirectionsWhatWeTransportBlock.vue?vue&type=template&id=87625db4&scoped=true&"
import script from "./DirectionsWhatWeTransportBlock.vue?vue&type=script&lang=js&"
export * from "./DirectionsWhatWeTransportBlock.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsWhatWeTransportBlock.vue?vue&type=style&index=0&id=87625db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87625db4",
  null
  
)

export default component.exports